import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Col, Form, Row, Table } from 'react-bootstrap';
import Address from '../../../../website/components/stateless/Address';
import StarRack from '../../../../website/components/stateless/StarRack';
import styles from './FacilitySelectTable.scss';

export default class FacilitySelectTable extends React.Component {
  static propTypes = {
    starStyling: PropTypes.string,
    handleChange: PropTypes.func,
    handleSelectAllChange: PropTypes.func,
    liveFacilities: PropTypes.array,
    enabledFacilities: PropTypes.object,
  };

  allFacilitiesEnabled(enabledFacilities, liveFacilities) {
    let allFacilitiesEnabled = true;

    for (const facility of liveFacilities) { // eslint-disable-line no-restricted-syntax
      if (!enabledFacilities[facility.id]) {
        allFacilitiesEnabled = false;
        break;
      }
    }

    return allFacilitiesEnabled;
  }

  handleChange = id => ({ target }) => {
    this.props.handleChange(id, { target });
  }

  render() {
    const { liveFacilities, enabledFacilities } = this.props;
    const enabledLiveFacilities = liveFacilities.filter(facility => enabledFacilities[facility.id]);

    return (
      <Row className={styles.row}>
        <Col md={9} sm={18}>
          <Table condensed className={styles.table}>
            <thead style={{ border: 'none' }}>
              <tr>
                <td>
                  <Form.Check
                    className={styles.checkbox}
                    type="checkbox"
                    // label="Select All"
                    checked={this.allFacilitiesEnabled(enabledFacilities, liveFacilities)}
                    onChange={this.props.handleSelectAllChange}
                  />
                </td>
                <td className={styles.checkbox}>
                  <Form.Label className={styles.label}>
                    <b>Facility</b>
                  </Form.Label>
                </td>
                <td className={styles.checkbox}>
                  <Form.Label className={styles.label}>
                    <b>Location</b>
                  </Form.Label>
                </td>
                {this.props.starStyling ?
                  <td className={styles.checkbox}>
                    <Form.Label className={styles.label}>
                      <b>Reviews</b>
                    </Form.Label>
                  </td>
                  : null}
              </tr>
            </thead>
            <tbody>
              {liveFacilities.map((facility, key) => (
                <tr key={key}>
                  <td className={`${styles.facilityCheckBox}`}><Form.Check
                    className={`${styles.checkbox}`}
                    type="checkbox"
                    id={`${facility.id}`}
                    // label={`${facility.id}`}
                    onChange={this.handleChange(facility.id)}
                    checked={enabledFacilities[facility.id]}
                  />
                  </td>
                  <td className={styles.checkbox}>
                    <Form.Label className={styles.label}>
                      {facility.displayName}
                    </Form.Label>
                  </td>
                  <td className={styles.checkbox}>
                    <Form.Label className={styles.label}>
                      <Address className={styles.address} {...facility.address} />
                    </Form.Label>
                  </td>
                  {this.props.starStyling ?
                    <td className={styles.checkbox}>
                      <Form.Label className={styles.label}>
                        <StarRack
                          rating={facility.rating || 0}
                          style={styles.starRack}
                          className={this.props.starStyling}
                        />
                      </Form.Label>
                      <Form.Label className={styles.label}>
                        {facility.reviewsCount} Reviews
                      </Form.Label>
                    </td>
                    : null}
                </tr>))
              }
              <tr />
            </tbody>
          </Table>
        </Col>
        <Col md={3} sm={6} className={styles.selectedFacilities}>
          <ul className="list-unstyled">
            <li className={styles.checkbox}>
              <Form.Label className={styles.label}>
                <b>Selected Facilities</b>
              </Form.Label>
            </li>
            {enabledLiveFacilities.map((facility, key) => (
              <li key={key} className={styles.checkbox}>
                <Form.Label className={styles.label}>
                  <span className={styles.delete} onClick={this.handleChange(facility.id)}>
                    &times;
                  </span>
                  {' '}
                  {facility.displayName}
                </Form.Label>
              </li>))
            }
          </ul>
        </Col>
      </Row>
    );
  }
}

FacilitySelectTable.fragments = {
  facility: gql`
    fragment FacilitySelectTableFacility on Facility {
      rating
      displayName
      reviewsCount
      address {
        ...FacilityAddress
      }
    }

    ${Address.fragments.address}
  `,
};
